module.exports = __webpack_public_path__ + "static/img/swiperitem04.0d96a19d.jpg";